/**
 * Shared Stage B field-error helpers for editable Excel import preview tables.
 * Module-specific clone, payload, and validatePreviewBeforeConfirm stay in each *-import.js.
 */
export default {
  data() {
    return {
      confirmFieldErrors: {},
    };
  },

  methods: {
    getFieldError(rowIndex, fieldKey) {
      return this.confirmFieldErrors?.[rowIndex]?.[fieldKey] || "";
    },

    hasConfirmFieldErrors() {
      return Object.keys(this.confirmFieldErrors || {}).length > 0;
    },

    setConfirmFieldErrors(fieldErrors) {
      this.confirmFieldErrors = fieldErrors || {};
    },

    clearConfirmFieldErrors() {
      this.confirmFieldErrors = {};
    },

    onPreviewFieldInput(rowIndex, fieldKey) {
      if (this.confirmFieldErrors?.[rowIndex]?.[fieldKey]) {
        this.$delete(this.confirmFieldErrors[rowIndex], fieldKey);
        if (!Object.keys(this.confirmFieldErrors[rowIndex]).length) {
          this.$delete(this.confirmFieldErrors, rowIndex);
        }
      }
    },

    applyConfirmBackendErrors(error, options = {}) {
      if (error?.response?.status !== 422) {
        return false;
      }

      const fieldErrors = this.printImportConfirmErrors(error.response, options);
      this.setConfirmFieldErrors(fieldErrors);

      if (options.openTimetableEditOnError && Object.keys(fieldErrors).length) {
        const firstRow = Number(Object.keys(fieldErrors)[0]);
        if (!Number.isNaN(firstRow) && typeof this.showPreviewEdit === "function") {
          this.showPreviewEdit(firstRow);
        }
      }

      return Object.keys(fieldErrors).length > 0;
    },
  },
};
